// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceDto } from './IServiceDto';
import {
    IServiceDtoFromJSON,
    IServiceDtoFromJSONTyped,
    IServiceDtoToJSON,
    IServiceDtoToJSONTyped,
} from './IServiceDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageServiceDto
 */
export interface IPageServiceDto {
    /**
     * 
     * @type {number}
     * @memberof IPageServiceDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageServiceDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageServiceDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IServiceDto>}
     * @memberof IPageServiceDto
     */
    content?: Array<IServiceDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageServiceDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageServiceDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageServiceDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageServiceDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageServiceDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageServiceDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageServiceDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageServiceDto interface.
 */
export function instanceOfIPageServiceDto(value: object): value is IPageServiceDto {
    return true;
}

export function IPageServiceDtoFromJSON(json: any): IPageServiceDto {
    return IPageServiceDtoFromJSONTyped(json, false);
}

export function IPageServiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageServiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IServiceDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageServiceDtoToJSON(json: any): IPageServiceDto {
    return IPageServiceDtoToJSONTyped(json, false);
}

export function IPageServiceDtoToJSONTyped(value?: IPageServiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IServiceDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

